import { validateUrlParam } from '../../_shared/utils/url/url.helpers';

export const validateCustomMapUrl = (mapUrl: string): boolean => {
  return mapUrl.length > 0 && validateUrlParam(mapUrl);
};
